module.exports = __webpack_public_path__ + "img/radar_color.f74127aa.svg";